import { numberWithCommas } from 'utility';
import jMoment from 'moment-jalaali';
import { STATUSES } from '../../constants/SubscriptionConstants';

const columns = (currencyText) => [
  {
    title: 'شناسه',
    field: 'id',
    align: 'center',
    filtering: false,
    sorting: false,
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'تاریخ ایجاد',
    field: 'creationDate',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rc) =>
      rc?.creationDate ? jMoment(rc.creationDate).format('dddd, jD jMMMM jYYYY') : '-',
  },

  {
    title: 'سرویس‌دهنده',
    field: 'subscriber', // 1384
    align: 'center',
    filtering: false,
    render: (r) => r?.subscriber?.name ?? '-',
  },
  
  {
    title: `میزان مصرف - ${currencyText}`,
    field: 'usedAmount', // 1384
    align: 'center',
    sorting: false,
    filtering: false,
    render: (rc) => (rc?.usedAmount != null ? numberWithCommas(rc?.usedAmount) : '-'),
  },
  {
    title: 'دفعات مصرف',
    field: 'usageCount', // 1384
    align: 'center',
    sorting: false,
    filtering: false,
    render: (rc) => (rc?.usageCount != null ? numberWithCommas(rc?.usageCount) : '-'),
  },
  {
    title: 'وضعیت',
    field: 'status', // SUBSCRIPTION_NOT_VERIFY , SUBSCRIPTION_VERIFY, SUBSCRIPTION_CONFIRM,
    align: 'center',
    sorting: false,
    filtering: false,
    render: (r) =>
      !r?.status ? '-' : STATUSES.find((v) => v?.value === r.status)?.label ?? r.status,
  },
];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, columnsId, generateData };
